import { CreateChartPreferencesRecordContext, UpdateChartPreferencesContext } from "@trinity/chat-components/containers/ChartPreferences/context.js";
import { useChatApiClient } from "@trinity/chat-components/containers/Chat/useApiClient.js";

type Props = {
  children: React.ReactNode;
};

export const ChartRecordsContainer = (props: Props) => {

  const apiClient = useChatApiClient();

  return (
    <UpdateChartPreferencesContext.Provider value={apiClient.chatCharts.updateChartRecordOverride}>
      <CreateChartPreferencesRecordContext.Provider value={apiClient.chatCharts.createChartRecord}>
        {props.children}
      </CreateChartPreferencesRecordContext.Provider>
    </UpdateChartPreferencesContext.Provider>
  );
};